$(document).on("click",".dropdown-block",function() {
   $(this).toggleClass("active")
   $(this).next().slideToggle();
});
$(document).on("click",".menu_wrapper----col span",function() {
   $(this).parents(".menu_wrapper----col").toggleClass("active");
   $(this).parents(".menu_wrapper----col").next(".custom_wrapper_item_ul").slideToggle();
});

$(document).on("click",".sub_menu_wrapper",function() {
   $(this).toggleClass("active")
   $(this).next(".grandchild").slideToggle();
});



$(document).on("click", ".link_list_main_title", function() {
    if ($(window).width() <= 700) {
        $(this).parents(".link_list_main_body").toggleClass('open');
        $(this).parents(".link_list_main_body").find('.link_list_main_wrapper').slideToggle();
    }
});


$(document).on("click", ".variant-picker__option-values label", function() {
   setTimeout(function() {
      fetch(`${window.location.href}`).then((response) => {
         return response.text();
      })
      .then((responseText) => {
         const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.baadmay-gateway-wrapper');
         document.querySelector('.baadmay-gateway-wrapper').innerHTML = html.innerHTML;
      })
      .catch(e => {
         console.error(e);
      })
      .finally(() => {
      });
   }, 150);
});
